module.exports = __webpack_public_path__ + "cd45b3f7a5392a58081926c272725421.svg";